import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "xmodal-wrapper",
  id: "search-page-filters"
}
const _hoisted_2 = { class: "xmodal-inner" }
const _hoisted_3 = { class: "xmodal" }
const _hoisted_4 = { class: "xmodal-buttons" }
const _hoisted_5 = { key: 0 }

import { computed } from "vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import { FilterDefinition } from "@/types/search-page";

import SearchPageFilterOptions from "@/components/v2/search-page/SearchPageFilterOptions.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageFiltersModal',
  setup(__props) {

const searchPageStore = useSearchPageStore();

const filterDefinition = computed<FilterDefinition>(() =>
	searchPageStore.searchPageState.filters.find(
		(f: FilterDefinition) =>
			f.filterCategoryId ===
			searchPageStore.searchPageState.filterModal.filterCategoryId
	)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "xmodal-close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(searchPageStore).closeFilterModal && _unref(searchPageStore).closeFilterModal(...args)))
        }, " X "),
        _createElementVNode("h2", null, _toDisplayString(filterDefinition.value.description), 1),
        _createElementVNode("div", {
          style: {"text-align":"left","max-height":"300px","overflow-y":"auto"},
          class: _normalizeClass({
					modalActive: _unref(searchPageStore).searchPageState.filterModal.active,
				})
        }, [
          _createVNode(SearchPageFilterOptions, {
            filterDefinition: filterDefinition.value,
            showAllFilterOptions: true
          }, null, 8, ["filterDefinition"])
        ], 2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(searchPageStore).closeFilterModal && _unref(searchPageStore).closeFilterModal(...args)))
          }, [
            _createTextVNode(" Show " + _toDisplayString(_unref(searchPageStore).searchPageState.query.totalCount) + " Result", 1),
            (_unref(searchPageStore).searchPageState.query.totalCount != 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "s"))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})